import ButtonBase from '@material-ui/core/ButtonBase';
import Paper from '@material-ui/core/Paper';
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import {useHistory} from 'react-router-dom/cjs/react-router-dom.min';

const useStyles = makeStyles((theme) => ({
  fullWidth: {
    width: '100%',
    fontSize: 0,
    borderRadius: 5,
    boxShadow: 'none',
  },
  fullHeight: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    boxShadow: 'none',
  },
}));

export default React.memo(function ButtonImage({src, alt, href, ...props}) {
  const classes = useStyles();
  const history = useHistory();
  const REDIRECT_URL =
    'https://api.pezeshket.com/files/pezeshket-public/app-genral-config/b1/3/b13dff3d-4030-4b93-9f27-f7d97478a5ea.png';

  return (
    <>
      <button
        style={{border: 'none', background: 'none', padding: 0, margin: 0}}
        onClick={() => {
          if (src === REDIRECT_URL) {
            history.push('/app#5');
          } else {
            href.includes('https')
              ? history.push(href)
              : (window.location.href = href);
          }
        }}
      >
        <ButtonBase
          className={clsx(classes.fullWidth, classes.fullHeight)}
          focusRipple
          {...props}
        >
          <Paper className={clsx(classes.fullWidth, classes.fullHeight)}>
            <img
              className={classes.fullWidth}
              src={src}
              alt={alt}
              style={{boxShadow: 'none'}}
            />
          </Paper>
        </ButtonBase>
      </button>
    </>
  );
});
